<template>
  <div>
    <div v-for="item in items" :key="item.id">
      <PermissionGroupItem
        :item="item.sourceName"
        :isSwitchable="item.isSwitchable"
      />
      <div v-for="permission in item.rights" :key="permission.id">
        <PermissionItem :item="permission" :isSwitchable="item.isSwitchable" />
      </div>
    </div>
    <Empty
      :stat="loadStat"
      :icon="require('@/static/ic_permission_empty.png')"
    />
  </div>
</template>
<script>
import PermissionItem from './PermissionItem'
import PermissionGroupItem from './PermissionGroupItem'
import Empty from '../comm/Empty'
import config from '@/api/config'
import http from '@/api/http'

export default {
  name: 'Permission',
  components: {
    Empty,
    PermissionGroupItem,
    PermissionItem
  },
  data() {
    return {
      items: [],
      loadStat: 0
    }
  },
  created() {
    const url = config.baseUrl + '/Right/List/Groups'
    // Ykt-ViewState
    // Ykt-Token
    this.loadStat = 0
    http.post(url, {}).then(response => {
      this.items = response.detail
      console.log(JSON.stringify(response.data))
      this.loadStat = this.items && this.items.length != 0 ? 2 : 1
    })
    if(window.goods&&window.goods.updatePermission){
      window.goods.updatePermission()
    }
  }
}
</script>

<style scoped>
</style>